module.exports = "/_next/static/images/bloomberg-5ff43aea9b2b14c3d4bab9f531e9bd93.png";